import { AsyncPipe } from '@angular/common';
import { Component, ChangeDetectionStrategy, OnInit, OnDestroy, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { RibbonSliderFilterInterface } from '@modules/slider/interfaces/ribbon-slider.interface';

import { EventRibbonCardComponent } from '../../card/event-ribbon-card/event-ribbon-card.component';
import { EventsService } from '../../shared/services/events.service';
import { RibbonSliderSectionComponent } from '../../slider/ribbon-slider-section/ribbon-slider-section.component';
import { EventModel } from '../models/event.model';
import { SectionHeadlineComponent } from '../section-headline/section-headline.component';

@Component({
  selector: 'mb-event-ribbon-section',
  templateUrl: './event-ribbon-section.component.html',
  styleUrls: ['./event-ribbon-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SectionHeadlineComponent, RibbonSliderSectionComponent, EventRibbonCardComponent, AsyncPipe, TranslatePipe],
})
export class EventRibbonSectionComponent implements OnInit, OnDestroy {
  private eventsService = inject(EventsService);

  private PAST_EVENTS: EventModel[] = [];
  private UPCOMING_EVENTS: EventModel[] = [];

  public events$ = new ReplaySubject<EventModel[]>();
  public filters: RibbonSliderFilterInterface[] = [];
  public destroy$ = new Subject<boolean>();

  constructor() {
    this.filters = [
      {
        label: 'UPCOMING_EVENTS',
        value: 'UPCOMING_EVENTS',
      },
      {
        label: 'PAST_EVENTS',
        value: 'PAST_EVENTS',
      },
    ];
  }

  ngOnInit(): void {
    this.eventsService
      .getEvents()
      .pipe(takeUntil(this.destroy$))
      .subscribe(([upcomingEvents, pastEvents]) => {
        this.UPCOMING_EVENTS = upcomingEvents;
        this.PAST_EVENTS = pastEvents;
        if (this.UPCOMING_EVENTS.length) {
          this.filters[0].active = true;
          this.events$.next(this.UPCOMING_EVENTS);
        } else {
          this.filters[0].disabled = true;
          this.filters[1].active = true;
          this.events$.next(this.PAST_EVENTS);
        }
      });

    this.eventsService.pendingUpcomingRegistrations$
      .pipe(takeUntil(this.destroy$))
      .subscribe((pendingRegistrations) => {
        this.filters[0].count = pendingRegistrations;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  public filtered(filter: RibbonSliderFilterInterface) {
    this.events$.next(filter.value === 'PAST_EVENTS' ? this.PAST_EVENTS : this.UPCOMING_EVENTS);
  }
}
